import { render, staticRenderFns } from "./CompanyDocument.vue?vue&type=template&id=4d0713c2&scoped=true&"
import script from "./CompanyDocument.vue?vue&type=script&lang=ts&"
export * from "./CompanyDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0713c2",
  null
  
)

export default component.exports